import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import DOMPurify from "isomorphic-dompurify";

const TranslatedMessage = (props) => {
	const intl = useIntl();

	const sanitizedHTML = useMemo(() => {
		const rawHTML = intl.formatMessage({ id: props.id });
		return DOMPurify.sanitize(rawHTML);
	}, [intl, props.id]);

	return <div dangerouslySetInnerHTML={{ __html: sanitizedHTML }} />;
};

export default TranslatedMessage;
